import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { offersUpdate, applyUpdate, getWaiting, subscribeWaiting } from './updatePrompt';
import '../styles/UpdateBanner.css';

// "A new version is ready." It is shown only when a new service worker is
// waiting, and never on a logging screen (offersUpdate). Nothing happens until
// the athlete presses Reload.
const UpdateBanner = () => {
  const { pathname } = useLocation();
  const [registration, setRegistration] = useState(getWaiting);

  useEffect(() => subscribeWaiting(setRegistration), []);

  if (!registration || !offersUpdate(pathname)) return null;

  return (
    <div className="update-banner" role="status">
      <span>A new version of LTS is ready.</span>
      <button type="button" className="btn-primary" onClick={() => applyUpdate(registration)}>
        Reload
      </button>
    </div>
  );
};

export default UpdateBanner;
